@if (progress.visible()) {
  <div
    class="nav-progress"
    [class.nav-progress--finishing]="progress.finishing()"
    role="progressbar"
    aria-busy="true"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="(progress.status() * 100) | number: '1.0-0'"
    aria-label="Loading page"
  >
    <div
      class="nav-progress__bar"
      [style.transform]="'translate3d(' + progress.barTranslatePercent() + '%,0,0)'"
    >
      <div class="nav-progress__peg"></div>
    </div>
  </div>
}
